import { render, staticRenderFns } from "./MyStaffHome.vue?vue&type=template&id=07d95472&scoped=true"
import script from "./MyStaffHome.vue?vue&type=script&lang=js"
export * from "./MyStaffHome.vue?vue&type=script&lang=js"
import style0 from "./MyStaffHome.vue?vue&type=style&index=0&id=07d95472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d95472",
  null
  
)

export default component.exports